import { render, staticRenderFns } from "./HistoryMain.vue?vue&type=template&id=1b7041fa"
import script from "./HistoryMain.vue?vue&type=script&lang=js"
export * from "./HistoryMain.vue?vue&type=script&lang=js"
import style0 from "./HistoryMain.vue?vue&type=style&index=0&id=1b7041fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports